import { useCallback, useState } from 'react';

import { useParams } from 'react-router-dom';

import useFeatureFlags from 'api/useFeatureFlags';
import { Offer } from 'common/contracts';
import { EFeatureFlag } from 'constants/enums';

interface IUseRollingOfferCheatsReturn {
  cheatsOffer: Offer | null;
  cheatsOfferId: string | null;
  hasFeatureFlagCheats: boolean;
  onOpenCheats: (offer: Offer) => void;
  handleCloseCheats: () => void;
}

/**
 * Encapsulates cheats-related state and feature flag logic
 * for the Rolling Offers table.
 *
 * @example
 * const { cheatsOffer, cheatsOfferId, hasFeatureFlagCheats, onOpenCheats, handleCloseCheats } =
 *   useRollingOfferCheats();
 */
export const useRollingOfferCheats = (): IUseRollingOfferCheatsReturn => {
  const { publisherId } = useParams();
  const { featureFlags } = useFeatureFlags({ publisherId });

  const [cheatsOffer, setCheatsOffer] = useState<Offer | null>(null);

  const hasFeatureFlagCheats = !!featureFlags?.[EFeatureFlag.DASHBOARD_ROLLING_CHEATS];

  const handleCloseCheats = useCallback((): void => {
    setCheatsOffer(null);
  }, []);

  const onOpenCheats = useCallback((offer: Offer): void => {
    setCheatsOffer(offer);
  }, []);

  let cheatsOfferId: string | null = null;
  if (cheatsOffer !== null && cheatsOffer.offerId !== undefined) {
    cheatsOfferId = cheatsOffer.offerId;
  }

  return {
    cheatsOffer,
    cheatsOfferId,
    hasFeatureFlagCheats,
    onOpenCheats,
    handleCloseCheats
  };
};
